import React from "react";
import cx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons/faAngleDown";
export var CategoryButton = function (_a) {
    var className = _a.className, title = _a.title, onClick = _a.onClick, isOpen = _a.isOpen;
    var baseClass = "group bg-transparent";
    var layoutClass = "w-full md:w-auto py-5 md:py-6 px-4 md:h-16";
    var textClass = "font-semibold text-left text-text-secondary leading-tighty md:leading-none text-base sm:text-sm";
    var borderClass = "border-b border-gray-100 md:border-b-0";
    var transitionClass = "hover:text-primary-200 transition-text duration-200";
    return (React.createElement("button", { className: cx(baseClass, layoutClass, textClass, borderClass, transitionClass, className), type: "button", onClick: onClick },
        React.createElement("p", { className: "flex justify-between md:block" },
            React.createElement("span", { className: "inline-block pr-4" }, title),
            React.createElement(FontAwesomeIcon, { icon: faAngleDown, height: "14", width: "7", className: cx({ "rotate-180": isOpen }, "md:group-hover:rotate-180 transition-transform duration-200") }))));
};
//# sourceMappingURL=CategoryButton.js.map